import { createAction, props } from '@ngrx/store';
import { ProjectsFilter } from '../../../../aumico-lib-projects-fe/src/lib/interfaces/projects-filter.interface';
import { MfaFilter } from '../../../../aumico-lib-users-fe/src/lib/interfaces/mfa-filter.interface';
import { TasksFilter } from '../interfaces/tasks-filter.interface';

export const setAccordionOpenState = createAction(
    '[UI] Set Accordion Open State',
    props<{ locationId: string; sectionId: string; isOpen: boolean }>(),
);

export const setSelectedTabState = createAction(
    '[UI] Set Selected Tab State',
    props<{ locationId: string; selectedTabKey: string }>(),
);
export const setScrollToTextState = createAction('[UI] Set Scroll To Text State', props<{ text: string }>());
export const clearScrollToText = createAction('[UI] Set Clear Scroll To Text State');

export const setProjectNavigationContext = createAction(
    '[UI] Set Project Navigation Context',
    props<{ context: 'my-projects' | 'all-projects' }>(),
);

export const setDoNotShowAgainMessage = createAction(
    '[UI] Set Do Not Show Again Message',
    props<{ messageId: string; value: boolean }>(),
);
export const unsetDoNotShowAgainMessage = createAction(
    '[UI] Unset Do Not Show Again Message',
    props<{ messageId: string }>(),
);
export const clearDoNotShowAgainMessages = createAction('[UI] Clear Do Not Show Again Messages');

export const setTasksFilter = createAction('[UI] Set Tasks Filter', props<{ filter: TasksFilter }>());

export const clearTasksFilter = createAction('[UI] Clear Tasks Filter');

export const setProjectsFilter = createAction('[UI] Set Projects Filter', props<{ filter: ProjectsFilter }>());

export const clearProjectsFilter = createAction('[UI] Clear Projects Filter');

export const setCompanySpecificProjectsFilter = createAction(
    '[UI] Set Company Specific Projects Filter',
    props<{ filter: ProjectsFilter }>(),
);

export const clearCompanySpecificProjectsFilter = createAction('[UI] Clear Company Specific Projects Filter');

export const setMfaFilter = createAction('[UI] Set Mfa Filter', props<{ filter: MfaFilter }>());

export const clearMfaFilter = createAction('[UI] Clear Mfa Filter');
